<template>
  <div v-if="!loading">
    <div class="card mb-3">
      <h4 class="text-uppercase"></h4>
      <div class="container-bg p-3">
        <h5>Naam</h5>
        <div class="flex-container bg-white mt-0 mb-3 p-3">
          <div class="col-12 p-0">
            <p>{{ itemgroup.title }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="card mb-3">
      <div class="container-bg p-3">
        <h5>Status</h5>
        <div class="flex-container bg-white mt-0 mb-3 p-3">
          <div class="col-12 p-0">
            <span> {{ itemgroup.active ? "Active" : "Inactive" }}</span> |
            <span> {{ itemgroup.public ? "Public" : "Private" }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="card mb-3">
      <div class="container-bg p-3">
        <h5>Omschrijving</h5>
        <div class="flex-container bg-white mt-0 mb-3 p-3">
          <div class="col-12 p-0">
            <p v-html="itemgroup.body"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="card mb-3">
      <div class="container-bg p-3">
        <h5>Commissies</h5>
        <div class="flex-container bg-white mt-0 mb-3 p-3">
          <div class="col-12 p-0">
            <ul v-if="itemgroup.committees && itemgroup.committees.length">
              <li v-for="com in itemgroup.committees" :key="'list' + com.id">
                {{ com.title }}
              </li>
            </ul>
            <p v-else>No committees</p>
          </div>
        </div>
      </div>
    </div>
    <div class="card mb-3">
      <div class="container-bg p-3">
        <h5>Leden</h5>
        <div class="flex-container bg-white mt-0 mb-3 p-3">
          <div class="col-12 p-0">
            <ul v-if="itemgroup.users && itemgroup.users.length">
              <li v-for="usr in itemgroup.users" :key="'list' + usr.id">
                {{ usr.display_name }}
              </li>
            </ul>
            <p v-else>No users</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    laden...
  </div>
</template>

<script>
export default {
  data() {
    return {
      itemgroup: {},
      loading: true,
    };
  },
  created() {
    this.$store
      .dispatch("get", "api/v1/itemgroups/" + this.$route.params.id)
      .then(({ data }) => {
        this.itemgroup = data.data;
        console.log(this.itemgroup);
        this.loading = false;
      });
  },
};
</script>

<style scoped>
.flex-container {
  display: flex;
  flex-flow: row wrap;
  position: relative;
  width: auto;
  margin-top: 10px;
  opacity: 1;
}

.flex-body {
  background: rgba(65, 146, 218, 0.25) 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
}

.item {
  flex: 1 1 18%;
  height: auto;
  margin: 4px;
  margin-right: 10px;
  padding: 10px 0;
  width: auto;
}
.card {
  padding: 0;
  border: unset;
}

.no-gutters {
  background: rgba(65, 146, 218, 0.25) 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
}

.card-footer {
  border-top: unset;
}
</style>
